import { CreateFormStrategy } from '../create-form.interface';

export class CreateProjectStrategy implements CreateFormStrategy {
  readonly header = 'create-form.project.create-project';
  readonly namePlaceholder = 'create-form.project.project-name-placeholder';
  readonly createButtonLabel = 'create-form.project.buttons.create-project';
  readonly cancelButtonLabel = 'create-form.project.buttons.cancel';
}
